export default __webpack_public_path__ + "static/media/chapter9.b30c25cb.jpg";